import { createFileRoute, useRouter } from '@tanstack/react-router';
import { useAuth } from '@/lib/auth/hooks/useAuth';
import usePageLoaded from '@/machinery/usePageLoaded';
import { useEffect } from 'react';
import InstallPrompt from '@/components/InstallPrompt';
import LoggedOut from '@/lib/common/components/LoggedOut';

export const Route = createFileRoute('/')({
    component: Index,
});

export default function Index() {
    const router = useRouter();
    const { user, userLoaded } = useAuth();

    const pageLoaded = usePageLoaded();

    useEffect(() => {
        if (user) {
            router.navigate({ to: '/dashboard', replace: true });
        }
    }, [router, user]);

    return (
        <>
            {!pageLoaded || !userLoaded ? (
                <div className='h-screen w-full animate-pulse bg-gray-500 bg-opacity-5' />
            ) : (
                <LoggedOut />
            )}
            <InstallPrompt />
        </>
    );
}
